/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $().ready(function(){
  $('.brandlogosSlick-carousel').slick({
    dots: false,  
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 3000, 
    arrows: false,
    infinite: true,
    autoplaySpeed: 1000,
    autoplay: true,
    responsive: [ 
      { 
        breakpoint: 768,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});

/*-------------------------------------------------------- 
    START : Featured Collection Slider 
--------------------------------------------------------*/ 
$(document).ready(function() {
      $(".featured-col-center__wrap").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      arrows: true,
      dots: true,
      autoplay: true,
       prevArrow:'<button class="slick-prev slick-arrow featured-col-arrow" aria-label="Previous" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><g><g><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0 L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251 c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow featured-col-arrow" aria-label="Next" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.005 512.005" style="enable-background:new 0 0 512.005 512.005;" xml:space="preserve"><g><g><path d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005 L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251 l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
             slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 899,
          settings: {
             slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
             slidesToShow: 2,
            slidesToScroll: 2
          }
        },
         {
          breakpoint: 541,
          settings: {
            arrows: false,
             slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          }
        }
      ]
    });

});

/*-------------------------------------------------------- 
    END : Featured Collection Slider 
--------------------------------------------------------*/

/*-------------------------------------------------------- 
    START :  Prouct Tabs Section
--------------------------------------------------------*/
$(document).ready(function() {
  if($('.section-tab-products').length){
      $('#tabs-nav button:first-child').addClass('active');
      $('.openTab_cust').find('.product-tabcontent').hide();
      $('.openTab_cust').find('.product-tabcontent:first').show();
      $('.product-tabcontent:first').addClass('firts__child');
      
      // Click function
      $('#tabs-nav button').click(function(){
        $('#tabs-nav button').removeClass('active');
        $(this).addClass('active');
        $('.openTab_cust').find('.product-tabcontent').hide();
        
        var activeTab = $(this).attr('data-target-content');
        //alert(activeTab);
        $('.openTab_cust').find('#'+activeTab).show();
        return false;
      });
  }
});

/*-------------------------------------------------------- 
    END : Prouct Tabs Section
--------------------------------------------------------*/

$(document).ready(function(){
      
    if($(".collection__filter-checkbox-list-outer-block").length){
  
        $(".collection__filter-checkbox-list-outer-block").each(function(){
              let list = $(this).find(".collection__filter-see-more-checkbox-list li:not(.no-product__hide)");
              let numToShow = 10;
              let button = $(this).find(".show_more_next");
              let numInList = list.length;
              list.hide();
              if (numInList > numToShow) {
                button.show();
              }
              list.slice(0, numToShow).show();                
        });
    
  
        $('body').on('click', '.collection__filter-checkbox-list-outer-block .show_more_next', function() {
            let list = $(this).closest(".collection__filter-checkbox-list-outer-block").find(".collection__filter-see-more-checkbox-list li:not(.no-product__hide)");
            let numToShow = 10;
            let button = $(this).closest(".collection__filter-checkbox-list-outer-block").find(".show_more_next");
            let numInList = list.length;        
            let showing = list.filter(':visible').length;
            list.slice(showing - 1, showing + numToShow).fadeIn();
            let nowShowing = list.filter(':visible').length;
            if (nowShowing >= numInList) {
              button.hide();
            }           
        });  
      
    }
  
});